import { DataFilter, DataFilterValidationError } from '../../../interface';
import { IsOneOfInStringListFold, Not, Rule, StringExists } from '@vendasta/automata';
import { StandardIds } from '@galaxy/crm/static';
import { CampaignSelectorComponent } from './campaign-selector/campaign-selector.component';
import { CampaignSelectorDisplayService } from './campaign-selector/campaign-selector-display.service';

const CAMPAIGN_ID_RULE = `{.activity_data['${StandardIds.ActivityCampaignID}']}`;
// This key is not used for comparisons since this filter is composed of a multi-valued AND rule
export const CAMPAIGN_ID_RULE_NAME = `${CAMPAIGN_ID_RULE}`;
export const CAMPAIGN_RULES = [
  new Not(new StringExists(CAMPAIGN_ID_RULE_NAME)),
  new StringExists(CAMPAIGN_ID_RULE_NAME),
  new IsOneOfInStringListFold(CAMPAIGN_ID_RULE_NAME),
  new Not(new IsOneOfInStringListFold(CAMPAIGN_ID_RULE_NAME)),
];
export class CampaignIdFilterComponent implements DataFilter {
  rules: Rule[] = CAMPAIGN_RULES;

  dataEntryComponent = CampaignSelectorComponent;
  displayService = CampaignSelectorDisplayService;
  comparisonLabels = [
    'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.VALUE_EXISTS',
    'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.VALUE_NOT_EXISTS',
    'AUTOMATIONS.EDITOR.FILTERS.CUSTOM_DATA.COMPARISON.STRING_TYPE.IS_ONE_OF',
    'AUTOMATIONS.EDITOR.FILTERS.CUSTOM_DATA.COMPARISON.STRING_TYPE.IS_NOT_ONE_OF',
  ];
  label = 'AUTOMATIONS.EDITOR.FILTERS.CAMPAIGN_DATA.DATA_LABELS.ID';
  validationError: DataFilterValidationError | undefined;
}
